import { createReducer } from '@reduxjs/toolkit';
import { IModerationPostsState as State, Post } from '../types';
import { getSpotPolicyFromString } from '../../utils';
import * as actions from '../actions';

const { getSpotItemsSuccess, setConversationPolicy } = actions;

const initialState: State = {
  posts: {}
};

const postsReducer = createReducer(initialState, {
  [getSpotItemsSuccess.type]: (state, { payload: { posts = [] } }) => {
    setPosts(state, posts);
  },
  [setConversationPolicy.type]: (
    state,
    { payload: { conversationId, policy = 'approve_all' } }
  ) => {
    const post = state.posts[conversationId];

    if (post) {
      post.policy = policy;
    }
  }
});

function setPosts(state: State, posts: Partial<Post>[]) {
  posts.forEach(post => setPost(state, post));
}

function setPost(state: State, post: Partial<Post> = {}) {
  const { id } = post;

  if (!id) {
    console.error('setPost - id is required', post);
    // reportError
  }
  const createdPost = createPostModelObject(post);

  state.posts = { ...state.posts, [id]: createdPost };
}

function createPostModelObject(options: Partial<Post> = {}): Post {
  const { id, title, postUrl, policy = 'approve_all' } = options;

  return {
    id,
    title,
    postUrl,
    policy: getSpotPolicyFromString(policy as string)
  };
}

export { postsReducer };
